// extracted by mini-css-extract-plugin
export default {"container":"YigTo","result-message":"mZWTS","scrollable":"bYvhJ","scrollable-content":"rtVb7"};